import { Base } from '@models/base.model';
import { PageObject } from '@models/page-object.model';
import { serializable, deserialize } from 'serializr';

export class ByTypeCount extends Base implements PageObject {
  @serializable
  public type: number;
  @serializable
  public count: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(ByTypeCount, input));
  }
}
